import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Thumbnail from "components/Thumbnail.jsx";

import thumbnailsStyle from "assets/jss/material-kit-react/views/homePageSections/thumbnails.jsx";

const API_DEFAULT_RANDOM = 'clips?_start=0&_end=12&_sort=rand&_order=DESC&source=front';
const API_DEFAULT = 'clips?_start=0&_end=12&_order=DESC&source=front';

class ThumbnailsSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clips: [],
    };
  }

  componentDidMount() {
    this.fetchThumbnails(this.props);
  }

  componentWillReceiveProps(props) {
    this.fetchThumbnails(props);
  }

  fetchThumbnails(nextprops){
    const api_base = process.env.REACT_APP_API_BASE;
      const url = api_base + (nextprops.query === '' ? API_DEFAULT_RANDOM : API_DEFAULT ) + '&q=' + nextprops.query;
      fetch(url)
        .then(response => response.json())
        .then(data => this.setState({ clips: data }))
        .catch(function(error) {
          console.log('Erreur lors du fetch des thumbnails : ' + error.message);
        });
  }

  render() {
    const { classes } = this.props;
    const { clips } = this.state;

    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          {
            clips.length > 0 ? (
              clips.map(clip =>
                <GridItem xs={12} sm={6} md={4} key={clip.id}>
                  <Thumbnail id={clip.id} youtube_id={clip.youtube_id} sentence={clip.sentence} start_time={clip.start_time} end_time={clip.end_time} />
                </GridItem>
              )
            ) : (
              <span className={classes.noVideoAvailable}>Aucune vidéo correspondante.</span>
            )
          }
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(thumbnailsStyle)(ThumbnailsSection);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/ThumbnailsSection.jsx